import Vue from 'vue'
import App from '@/App.vue'
import '@/registerServiceWorker'
import router from '@/router'
import { store } from '@/stores'
import vuetify from '@/plugins/vuetify';

Vue.config.productionTip = false
Vue.config.devtools = true

new Vue({
  router,
  store,
  vuetify,
  // eslint-disable-next-line
  render: h => h(App)
}).$mount('#app')
